<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <h2>Bezeichnung:</h2>
  <input type="text" placeholder="Projekte..." [(ngModel)]="template.name">

  <h2>Icon:</h2>
  <div id="icons">
    <div class="icon-container selectable" *ngFor="let icon of icons" [class.selectedItem]="template.icon === icon" (click)="template.icon = icon">
      <ion-icon [name]="icon"></ion-icon>
    </div>
  </div>

  <h2>Tags:</h2>
  <ion-chip mode="ios" class="button-chip selectable" *ngFor="let tag of availabeleTags" (click)="tag.checked = !tag.checked" [class.selectedItem]="tag.checked">
    <div class="chip-dott" [ngStyle]="{'background': tag.color}"></div>
    <ion-label>{{tag.description}}</ion-label>
  </ion-chip>

  @if(availabeleTags.length == 0) {
    <ion-chip mode="ios" class="button-chip selectable" (click)="showTagOverview()">
      <ion-label>Tags verwalten...</ion-label>
    </ion-chip>
  }
  

  <h2>Mehr:</h2>
  <div id="more-filters">
    <ion-chip mode="ios" (click)="openUserSelect($event)" class="button-chip selectable" [class.selectedItem]="template.employees.length > 0">
      <ion-icon name="fa-user-business"></ion-icon>
      <ion-label>Mitarbeiter <span *ngIf="template.employees.length > 0">({{template.employees.length}})</span></ion-label>
    </ion-chip>
    <ion-chip mode="ios" (click)="openEditorFilter($event)" class="button-chip selectable" [class.selectedItem]="template.editorFilter != 'all'">
      <ion-icon name="fa-hammer"></ion-icon>
      <ion-label>Bearbeiter/Beobachter</ion-label>
    </ion-chip>
    <ion-chip mode="ios" (click)="openCardViewEditor($event)" class="button-chip selectable" [class.selectedItem]="cardViewAnyActive">
      <ion-icon name="fa-list"></ion-icon>
      <ion-label>Karten-Ansicht <span *ngIf="cardViewInactiveLength > 0">({{cardViewInactiveLength}})</span></ion-label>
    </ion-chip>
    <ion-chip mode="ios" class="button-chip selectable" (click)="template.colored = !template.colored" [class.selectedItem]="template.colored">
      <ion-icon name="fa-colors"></ion-icon>
      <ion-label>Farblich anpassen</ion-label>
    </ion-chip>
    <ion-chip mode="ios" class="button-chip selectable" (click)="template.public = !template.public" [class.selectedItem]="template.public"> 
      <ion-icon name="fa-user-group"></ion-icon>
      <ion-label>Für alle Mitarbeiter</ion-label>
    </ion-chip>
    <ion-chip mode="ios" class="button-chip selectable" (click)="openStatusView($event)" [class.selectedItem]="statusViewInactiveLength > 0">
      <ion-icon name="fa-eye-slash"></ion-icon>
      <ion-label>Status verstecken <span *ngIf="statusViewInactiveLength > 0">({{statusViewInactiveLength}})</span></ion-label>
    </ion-chip>
  </div>

</ion-content>

<ion-footer class="ion-padding">
  <ion-toolbar>
    <ion-button mode="ios" (click)="save()">Speichern</ion-button>
  </ion-toolbar>
</ion-footer>
